import React from "react";
import {Grid} from "@mui/material";
import {BaseInput} from "../../../../designSystem/components/BaseInput";

export const BloodPressureForm = ({
  measurement,
  onChangeMeasurement,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={6}>
      <BaseInput
        type="number"
        onChange={e => onChangeMeasurement({...measurement, systolic: e.target.value})}
        value={measurement.systolic}
        placeholder="收縮壓(mmHg)"
      />
    </Grid>
    <Grid item xs={6}>
      <BaseInput
        type="number"
        onChange={e => onChangeMeasurement({...measurement, diastolic: e.target.value})}
        value={measurement.diastolic}
        placeholder="舒張壓(mmHg)"
      />
    </Grid>
  </Grid>
)